<div class="position-relative d-flex flex-column h-100  text-grey" 
  cdkDrag cdkDragRootElement=".cdk-overlay-pane"
  cdkDragBoundary="body"
  [cdkDragDisabled]="!toggleDialog">
  <div class="modal-header terminalDiv" cdkDragHandle>
    <h4 class="modal-title text-start flex-grow-1 text-white terminalHeading" id="modal-title">Terminal - {{ reqFromPod == false ? username : podName }}</h4>
    <i
      style="z-index: 1; margin: 0 .5rem"
      class="bi bi-arrows-fullscreen text-danger"
      [ngClass]="{
        'bi-arrows-fullscreen': !toggleFullScreen,
        'bi-fullscreen-exit': toggleFullScreen
      }"
      [title]="toggleFullScreen ? 'Exit full screen' : 'Full screen'"
      color="warn"
      (click)="onFullScreen()"
    ></i>
    <i
      style="z-index: 1; margin: 0 .5rem"
      class="bi bi-dash text-danger"
      [ngClass]="{
        'bi-dash-lg': !toggleDialog,
        'bi-fullscreen': toggleDialog,
        'minmax-dialog': toggleDialog
      }"
      color="warn"
      (click)="toggleDialogMinMax()"
      [title]="toggleDialog ? 'Maximize' : 'Minimize'"
    ></i>
    <i style="z-index: 1; margin: 0 .5rem" class="bi bi-x-lg text-danger" color="warn" mat-dialog-close title="Close"></i>
  </div>
  <div (resized)="onResize($event)" id="termContainer" #term></div>
</div>
